__turbopack_context__.v({
  "className": "eidi0W_className",
  "variable": "eidi0W_variable",
});
